import React from "react";
import PropTypes from "prop-types";
import Col from "antd/es/col";
import Row from "antd/es/row";

const CashDetailsColumn = ({ label, value }) => (
  <div className="left-margin">
    <Row>
      <Col span={20}>
        <span className="details-label">{label}</span>
      </Col>
      <Col span={4}>
        <span className="details-value">{value}</span>
      </Col>
    </Row>
  </div>
);

CashDetailsColumn.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CashDetailsColumn;
